export function writeCookie() {
    let date, expires;

    let value = 's' + Math.random().toString(36).substr(2, 9);
    
    date = new Date();
    date.setTime(date.getTime() + (24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toGMTString();

    document.cookie = "session=" + value + expires + "; path=/";
}

export function readCookie() {
    let i, c, ca, nameEQ = "session=";
    ca = document.cookie.split(';');

    for(i=0; i < ca.length; i++) {
        c = ca[i];
        while (c.charAt(0)==' ') {
            c = c.substring(1,c.length);
        }
        if (c.indexOf(nameEQ) == 0) {
            return c.substring(nameEQ.length,c.length);
        }
    }
    return '';
}